// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dh2T5DmyMOdlfdD5POkT {
  background-color: var(--button-color);
  border: 1px solid var(--button-color);
  color: var(--button-text-color);
  padding: 0.75em;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  border-radius: var(--border-radius);
  font-size: 1em;
  font-weight: 400;
  font-family: var(--text-font);
  pointer-events: auto;
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.1);
}

.H7J4m0NwXojDKuT1OB2p {
  border-radius: var(--border-radius) var(--border-radius) 0 0;
}

.SB5fNNgj72Z0_utmLT0v {
  background-color: var(--user-color);
  color: var(--text-color);
  border: 1px solid var(--user-color);
}

.dh2T5DmyMOdlfdD5POkT:hover {
  background-color: var(--button-hover-color);
  color: var(--button-text-color);
  cursor: pointer;
  box-shadow: none;
  border: 1px solid var(--button-hover-color);
}

.dh2T5DmyMOdlfdD5POkT:active {
  background-color: var(--button-hover-color);
  color: var(--button-text-color);
  box-shadow: none;
}

.dh2T5DmyMOdlfdD5POkT:disabled {
  background-color: var(--user-color);
  color: var(--disabled-text-color);
  border: 1px solid var(--text-color);
  box-shadow: none;
  cursor: not-allowed;
}

.SB5fNNgj72Z0_utmLT0v:hover {
  border: 1px solid var(--text-color);
  background-color: var(--user-color);
  color: var(--text-color);
  cursor: pointer;
  box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Button.module.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,2CAA2C;EAC3C,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;EAC3C,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".button {\n  background-color: var(--button-color);\n  border: 1px solid var(--button-color);\n  color: var(--button-text-color);\n  padding: 0.75em;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  border-radius: var(--border-radius);\n  font-size: 1em;\n  font-weight: 400;\n  font-family: var(--text-font);\n  pointer-events: auto;\n  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.1);\n}\n\n.flatBottom {\n  border-radius: var(--border-radius) var(--border-radius) 0 0;\n}\n\n.secondary {\n  background-color: var(--user-color);\n  color: var(--text-color);\n  border: 1px solid var(--user-color);\n}\n\n.button:hover {\n  background-color: var(--button-hover-color);\n  color: var(--button-text-color);\n  cursor: pointer;\n  box-shadow: none;\n  border: 1px solid var(--button-hover-color);\n}\n\n.button:active {\n  background-color: var(--button-hover-color);\n  color: var(--button-text-color);\n  box-shadow: none;\n}\n\n.button:disabled {\n  background-color: var(--user-color);\n  color: var(--disabled-text-color);\n  border: 1px solid var(--text-color);\n  box-shadow: none;\n  cursor: not-allowed;\n}\n\n.secondary:hover {\n  border: 1px solid var(--text-color);\n  background-color: var(--user-color);\n  color: var(--text-color);\n  cursor: pointer;\n  box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `dh2T5DmyMOdlfdD5POkT`,
	"flatBottom": `H7J4m0NwXojDKuT1OB2p`,
	"secondary": `SB5fNNgj72Z0_utmLT0v`
};
export default ___CSS_LOADER_EXPORT___;
